import styled from '@app/styled';
import { color, radius, transition } from '@app/theme';

export const ProgressBar = styled.div<{ progress: number }>`
    height: 4px;
    width: 100%;
    border-radius: ${radius('m')};
    background-color: ${color('custom.surface.primary100')};
    overflow: hidden;

    &::before {
        display: block;
        content: '';
        width: ${({ progress }) => Math.round(100 * progress)}%;
        height: 100%;
        background-color: ${color('custom.primary.600')};
        transition: width ${transition('default')};
    }
`;
